const uData = {
    "login": "srijan2498",
    "id": 47470062,
    "node_id": "MDQ6VXNlcjQ3NDcwMDYy",
    "avatar_url": "https://avatars.githubusercontent.com/u/47470062?v=4",
    "gravatar_id": "",
    "url": "https://api.github.com/users/srijan2498",
    "html_url": "https://github.com/srijan2498",
    "followers_url": "https://api.github.com/users/srijan2498/followers",
    "following_url": "https://api.github.com/users/srijan2498/following{/other_user}",
    "gists_url": "https://api.github.com/users/srijan2498/gists{/gist_id}",
    "starred_url": "https://api.github.com/users/srijan2498/starred{/owner}{/repo}",
    "subscriptions_url": "https://api.github.com/users/srijan2498/subscriptions",
    "organizations_url": "https://api.github.com/users/srijan2498/orgs",
    "repos_url": "https://api.github.com/users/srijan2498/repos",
    "events_url": "https://api.github.com/users/srijan2498/events{/privacy}",
    "received_events_url": "https://api.github.com/users/srijan2498/received_events",
    "type": "User",
    "site_admin": false,
    "name": "Srijan Tripathi",
    "company": "Cognizant",
    "blog": "https://srijan-tripathi-portfolio.000webhostapp.com/",
    "location": null,
    "email": null,
    "hireable": null,
    "bio": "An enthusiast frontend developer having love and passion for beautiful UI.",
    "twitter_username": null,
    "public_repos": 14,
    "public_gists": 0,
    "followers": 0,
    "following": 2,
    "created_at": "2019-02-09T05:58:36Z",
    "updated_at": "2023-02-05T05:07:44Z"
}

const rData = [
    {
        "id": 515909653,
        "node_id": "R_kgDOHsAoFQ",
        "name": "Analog-Digital-Clock",
        "full_name": "srijan2498/Analog-Digital-Clock",
        "private": false,
        "owner": {
            "login": "srijan2498",
            "id": 47470062,
            "node_id": "MDQ6VXNlcjQ3NDcwMDYy",
            "avatar_url": "https://avatars.githubusercontent.com/u/47470062?v=4",
            "gravatar_id": "",
            "url": "https://api.github.com/users/srijan2498",
            "html_url": "https://github.com/srijan2498",
            "followers_url": "https://api.github.com/users/srijan2498/followers",
            "following_url": "https://api.github.com/users/srijan2498/following{/other_user}",
            "gists_url": "https://api.github.com/users/srijan2498/gists{/gist_id}",
            "starred_url": "https://api.github.com/users/srijan2498/starred{/owner}{/repo}",
            "subscriptions_url": "https://api.github.com/users/srijan2498/subscriptions",
            "organizations_url": "https://api.github.com/users/srijan2498/orgs",
            "repos_url": "https://api.github.com/users/srijan2498/repos",
            "events_url": "https://api.github.com/users/srijan2498/events{/privacy}",
            "received_events_url": "https://api.github.com/users/srijan2498/received_events",
            "type": "User",
            "site_admin": false
        },
        "html_url": "https://github.com/srijan2498/Analog-Digital-Clock",
        "description": "It is a website which shows us time in analog as well as digital form. The technologies involved here are HTML, CSS, JavaScript.",
        "fork": false,
        "url": "https://api.github.com/repos/srijan2498/Analog-Digital-Clock",
        "forks_url": "https://api.github.com/repos/srijan2498/Analog-Digital-Clock/forks",
        "keys_url": "https://api.github.com/repos/srijan2498/Analog-Digital-Clock/keys{/key_id}",
        "collaborators_url": "https://api.github.com/repos/srijan2498/Analog-Digital-Clock/collaborators{/collaborator}",
        "teams_url": "https://api.github.com/repos/srijan2498/Analog-Digital-Clock/teams",
        "hooks_url": "https://api.github.com/repos/srijan2498/Analog-Digital-Clock/hooks",
        "issue_events_url": "https://api.github.com/repos/srijan2498/Analog-Digital-Clock/issues/events{/number}",
        "events_url": "https://api.github.com/repos/srijan2498/Analog-Digital-Clock/events",
        "assignees_url": "https://api.github.com/repos/srijan2498/Analog-Digital-Clock/assignees{/user}",
        "branches_url": "https://api.github.com/repos/srijan2498/Analog-Digital-Clock/branches{/branch}",
        "tags_url": "https://api.github.com/repos/srijan2498/Analog-Digital-Clock/tags",
        "blobs_url": "https://api.github.com/repos/srijan2498/Analog-Digital-Clock/git/blobs{/sha}",
        "git_tags_url": "https://api.github.com/repos/srijan2498/Analog-Digital-Clock/git/tags{/sha}",
        "git_refs_url": "https://api.github.com/repos/srijan2498/Analog-Digital-Clock/git/refs{/sha}",
        "trees_url": "https://api.github.com/repos/srijan2498/Analog-Digital-Clock/git/trees{/sha}",
        "statuses_url": "https://api.github.com/repos/srijan2498/Analog-Digital-Clock/statuses/{sha}",
        "languages_url": "https://api.github.com/repos/srijan2498/Analog-Digital-Clock/languages",
        "stargazers_url": "https://api.github.com/repos/srijan2498/Analog-Digital-Clock/stargazers",
        "contributors_url": "https://api.github.com/repos/srijan2498/Analog-Digital-Clock/contributors",
        "subscribers_url": "https://api.github.com/repos/srijan2498/Analog-Digital-Clock/subscribers",
        "subscription_url": "https://api.github.com/repos/srijan2498/Analog-Digital-Clock/subscription",
        "commits_url": "https://api.github.com/repos/srijan2498/Analog-Digital-Clock/commits{/sha}",
        "git_commits_url": "https://api.github.com/repos/srijan2498/Analog-Digital-Clock/git/commits{/sha}",
        "comments_url": "https://api.github.com/repos/srijan2498/Analog-Digital-Clock/comments{/number}",
        "issue_comment_url": "https://api.github.com/repos/srijan2498/Analog-Digital-Clock/issues/comments{/number}",
        "contents_url": "https://api.github.com/repos/srijan2498/Analog-Digital-Clock/contents/{+path}",
        "compare_url": "https://api.github.com/repos/srijan2498/Analog-Digital-Clock/compare/{base}...{head}",
        "merges_url": "https://api.github.com/repos/srijan2498/Analog-Digital-Clock/merges",
        "archive_url": "https://api.github.com/repos/srijan2498/Analog-Digital-Clock/{archive_format}{/ref}",
        "downloads_url": "https://api.github.com/repos/srijan2498/Analog-Digital-Clock/downloads",
        "issues_url": "https://api.github.com/repos/srijan2498/Analog-Digital-Clock/issues{/number}",
        "pulls_url": "https://api.github.com/repos/srijan2498/Analog-Digital-Clock/pulls{/number}",
        "milestones_url": "https://api.github.com/repos/srijan2498/Analog-Digital-Clock/milestones{/number}",
        "notifications_url": "https://api.github.com/repos/srijan2498/Analog-Digital-Clock/notifications{?since,all,participating}",
        "labels_url": "https://api.github.com/repos/srijan2498/Analog-Digital-Clock/labels{/name}",
        "releases_url": "https://api.github.com/repos/srijan2498/Analog-Digital-Clock/releases{/id}",
        "deployments_url": "https://api.github.com/repos/srijan2498/Analog-Digital-Clock/deployments",
        "created_at": "2022-07-20T09:07:10Z",
        "updated_at": "2022-07-20T09:07:37Z",
        "pushed_at": "2022-07-20T09:08:13Z",
        "git_url": "git://github.com/srijan2498/Analog-Digital-Clock.git",
        "ssh_url": "git@github.com:srijan2498/Analog-Digital-Clock.git",
        "clone_url": "https://github.com/srijan2498/Analog-Digital-Clock.git",
        "svn_url": "https://github.com/srijan2498/Analog-Digital-Clock",
        "homepage": null,
        "size": 4,
        "stargazers_count": 0,
        "watchers_count": 0,
        "language": "CSS",
        "has_issues": true,
        "has_projects": true,
        "has_downloads": true,
        "has_wiki": true,
        "has_pages": false,
        "has_discussions": false,
        "forks_count": 0,
        "mirror_url": null,
        "archived": false,
        "disabled": false,
        "open_issues_count": 0,
        "license": null,
        "allow_forking": true,
        "is_template": false,
        "web_commit_signoff_required": false,
        "topics": [

        ],
        "visibility": "public",
        "forks": 0,
        "open_issues": 0,
        "watchers": 0,
        "default_branch": "main"
    },
    {
        "id": 515943902,
        "node_id": "R_kgDOHsCt3g",
        "name": "Digital-World-Clock",
        "full_name": "srijan2498/Digital-World-Clock",
        "private": false,
        "owner": {
            "login": "srijan2498",
            "id": 47470062,
            "node_id": "MDQ6VXNlcjQ3NDcwMDYy",
            "avatar_url": "https://avatars.githubusercontent.com/u/47470062?v=4",
            "gravatar_id": "",
            "url": "https://api.github.com/users/srijan2498",
            "html_url": "https://github.com/srijan2498",
            "followers_url": "https://api.github.com/users/srijan2498/followers",
            "following_url": "https://api.github.com/users/srijan2498/following{/other_user}",
            "gists_url": "https://api.github.com/users/srijan2498/gists{/gist_id}",
            "starred_url": "https://api.github.com/users/srijan2498/starred{/owner}{/repo}",
            "subscriptions_url": "https://api.github.com/users/srijan2498/subscriptions",
            "organizations_url": "https://api.github.com/users/srijan2498/orgs",
            "repos_url": "https://api.github.com/users/srijan2498/repos",
            "events_url": "https://api.github.com/users/srijan2498/events{/privacy}",
            "received_events_url": "https://api.github.com/users/srijan2498/received_events",
            "type": "User",
            "site_admin": false
        },
        "html_url": "https://github.com/srijan2498/Digital-World-Clock",
        "description": "It is a digital world-clock that shows the current time of the selected country. It has a very beautiful and simple user interface. The technologies involved are HTML, CSS, JavaScript.",
        "fork": false,
        "url": "https://api.github.com/repos/srijan2498/Digital-World-Clock",
        "forks_url": "https://api.github.com/repos/srijan2498/Digital-World-Clock/forks",
        "keys_url": "https://api.github.com/repos/srijan2498/Digital-World-Clock/keys{/key_id}",
        "collaborators_url": "https://api.github.com/repos/srijan2498/Digital-World-Clock/collaborators{/collaborator}",
        "teams_url": "https://api.github.com/repos/srijan2498/Digital-World-Clock/teams",
        "hooks_url": "https://api.github.com/repos/srijan2498/Digital-World-Clock/hooks",
        "issue_events_url": "https://api.github.com/repos/srijan2498/Digital-World-Clock/issues/events{/number}",
        "events_url": "https://api.github.com/repos/srijan2498/Digital-World-Clock/events",
        "assignees_url": "https://api.github.com/repos/srijan2498/Digital-World-Clock/assignees{/user}",
        "branches_url": "https://api.github.com/repos/srijan2498/Digital-World-Clock/branches{/branch}",
        "tags_url": "https://api.github.com/repos/srijan2498/Digital-World-Clock/tags",
        "blobs_url": "https://api.github.com/repos/srijan2498/Digital-World-Clock/git/blobs{/sha}",
        "git_tags_url": "https://api.github.com/repos/srijan2498/Digital-World-Clock/git/tags{/sha}",
        "git_refs_url": "https://api.github.com/repos/srijan2498/Digital-World-Clock/git/refs{/sha}",
        "trees_url": "https://api.github.com/repos/srijan2498/Digital-World-Clock/git/trees{/sha}",
        "statuses_url": "https://api.github.com/repos/srijan2498/Digital-World-Clock/statuses/{sha}",
        "languages_url": "https://api.github.com/repos/srijan2498/Digital-World-Clock/languages",
        "stargazers_url": "https://api.github.com/repos/srijan2498/Digital-World-Clock/stargazers",
        "contributors_url": "https://api.github.com/repos/srijan2498/Digital-World-Clock/contributors",
        "subscribers_url": "https://api.github.com/repos/srijan2498/Digital-World-Clock/subscribers",
        "subscription_url": "https://api.github.com/repos/srijan2498/Digital-World-Clock/subscription",
        "commits_url": "https://api.github.com/repos/srijan2498/Digital-World-Clock/commits{/sha}",
        "git_commits_url": "https://api.github.com/repos/srijan2498/Digital-World-Clock/git/commits{/sha}",
        "comments_url": "https://api.github.com/repos/srijan2498/Digital-World-Clock/comments{/number}",
        "issue_comment_url": "https://api.github.com/repos/srijan2498/Digital-World-Clock/issues/comments{/number}",
        "contents_url": "https://api.github.com/repos/srijan2498/Digital-World-Clock/contents/{+path}",
        "compare_url": "https://api.github.com/repos/srijan2498/Digital-World-Clock/compare/{base}...{head}",
        "merges_url": "https://api.github.com/repos/srijan2498/Digital-World-Clock/merges",
        "archive_url": "https://api.github.com/repos/srijan2498/Digital-World-Clock/{archive_format}{/ref}",
        "downloads_url": "https://api.github.com/repos/srijan2498/Digital-World-Clock/downloads",
        "issues_url": "https://api.github.com/repos/srijan2498/Digital-World-Clock/issues{/number}",
        "pulls_url": "https://api.github.com/repos/srijan2498/Digital-World-Clock/pulls{/number}",
        "milestones_url": "https://api.github.com/repos/srijan2498/Digital-World-Clock/milestones{/number}",
        "notifications_url": "https://api.github.com/repos/srijan2498/Digital-World-Clock/notifications{?since,all,participating}",
        "labels_url": "https://api.github.com/repos/srijan2498/Digital-World-Clock/labels{/name}",
        "releases_url": "https://api.github.com/repos/srijan2498/Digital-World-Clock/releases{/id}",
        "deployments_url": "https://api.github.com/repos/srijan2498/Digital-World-Clock/deployments",
        "created_at": "2022-07-20T10:54:48Z",
        "updated_at": "2022-07-20T11:08:14Z",
        "pushed_at": "2022-07-20T11:08:11Z",
        "git_url": "git://github.com/srijan2498/Digital-World-Clock.git",
        "ssh_url": "git@github.com:srijan2498/Digital-World-Clock.git",
        "clone_url": "https://github.com/srijan2498/Digital-World-Clock.git",
        "svn_url": "https://github.com/srijan2498/Digital-World-Clock",
        "homepage": null,
        "size": 7,
        "stargazers_count": 0,
        "watchers_count": 0,
        "language": "HTML",
        "has_issues": true,
        "has_projects": true,
        "has_downloads": true,
        "has_wiki": true,
        "has_pages": false,
        "has_discussions": false,
        "forks_count": 0,
        "mirror_url": null,
        "archived": false,
        "disabled": false,
        "open_issues_count": 0,
        "license": null,
        "allow_forking": true,
        "is_template": false,
        "web_commit_signoff_required": false,
        "topics": [

        ],
        "visibility": "public",
        "forks": 0,
        "open_issues": 0,
        "watchers": 0,
        "default_branch": "main"
    },
    {
        "id": 597622777,
        "node_id": "R_kgDOI57_-Q",
        "name": "Filtry-App",
        "full_name": "srijan2498/Filtry-App",
        "private": false,
        "owner": {
            "login": "srijan2498",
            "id": 47470062,
            "node_id": "MDQ6VXNlcjQ3NDcwMDYy",
            "avatar_url": "https://avatars.githubusercontent.com/u/47470062?v=4",
            "gravatar_id": "",
            "url": "https://api.github.com/users/srijan2498",
            "html_url": "https://github.com/srijan2498",
            "followers_url": "https://api.github.com/users/srijan2498/followers",
            "following_url": "https://api.github.com/users/srijan2498/following{/other_user}",
            "gists_url": "https://api.github.com/users/srijan2498/gists{/gist_id}",
            "starred_url": "https://api.github.com/users/srijan2498/starred{/owner}{/repo}",
            "subscriptions_url": "https://api.github.com/users/srijan2498/subscriptions",
            "organizations_url": "https://api.github.com/users/srijan2498/orgs",
            "repos_url": "https://api.github.com/users/srijan2498/repos",
            "events_url": "https://api.github.com/users/srijan2498/events{/privacy}",
            "received_events_url": "https://api.github.com/users/srijan2498/received_events",
            "type": "User",
            "site_admin": false
        },
        "html_url": "https://github.com/srijan2498/Filtry-App",
        "description": "It is a react based application. The users can make use of this application to take their beautiful pictures to the next level by applying various filters from the options available in the application.",
        "fork": false,
        "url": "https://api.github.com/repos/srijan2498/Filtry-App",
        "forks_url": "https://api.github.com/repos/srijan2498/Filtry-App/forks",
        "keys_url": "https://api.github.com/repos/srijan2498/Filtry-App/keys{/key_id}",
        "collaborators_url": "https://api.github.com/repos/srijan2498/Filtry-App/collaborators{/collaborator}",
        "teams_url": "https://api.github.com/repos/srijan2498/Filtry-App/teams",
        "hooks_url": "https://api.github.com/repos/srijan2498/Filtry-App/hooks",
        "issue_events_url": "https://api.github.com/repos/srijan2498/Filtry-App/issues/events{/number}",
        "events_url": "https://api.github.com/repos/srijan2498/Filtry-App/events",
        "assignees_url": "https://api.github.com/repos/srijan2498/Filtry-App/assignees{/user}",
        "branches_url": "https://api.github.com/repos/srijan2498/Filtry-App/branches{/branch}",
        "tags_url": "https://api.github.com/repos/srijan2498/Filtry-App/tags",
        "blobs_url": "https://api.github.com/repos/srijan2498/Filtry-App/git/blobs{/sha}",
        "git_tags_url": "https://api.github.com/repos/srijan2498/Filtry-App/git/tags{/sha}",
        "git_refs_url": "https://api.github.com/repos/srijan2498/Filtry-App/git/refs{/sha}",
        "trees_url": "https://api.github.com/repos/srijan2498/Filtry-App/git/trees{/sha}",
        "statuses_url": "https://api.github.com/repos/srijan2498/Filtry-App/statuses/{sha}",
        "languages_url": "https://api.github.com/repos/srijan2498/Filtry-App/languages",
        "stargazers_url": "https://api.github.com/repos/srijan2498/Filtry-App/stargazers",
        "contributors_url": "https://api.github.com/repos/srijan2498/Filtry-App/contributors",
        "subscribers_url": "https://api.github.com/repos/srijan2498/Filtry-App/subscribers",
        "subscription_url": "https://api.github.com/repos/srijan2498/Filtry-App/subscription",
        "commits_url": "https://api.github.com/repos/srijan2498/Filtry-App/commits{/sha}",
        "git_commits_url": "https://api.github.com/repos/srijan2498/Filtry-App/git/commits{/sha}",
        "comments_url": "https://api.github.com/repos/srijan2498/Filtry-App/comments{/number}",
        "issue_comment_url": "https://api.github.com/repos/srijan2498/Filtry-App/issues/comments{/number}",
        "contents_url": "https://api.github.com/repos/srijan2498/Filtry-App/contents/{+path}",
        "compare_url": "https://api.github.com/repos/srijan2498/Filtry-App/compare/{base}...{head}",
        "merges_url": "https://api.github.com/repos/srijan2498/Filtry-App/merges",
        "archive_url": "https://api.github.com/repos/srijan2498/Filtry-App/{archive_format}{/ref}",
        "downloads_url": "https://api.github.com/repos/srijan2498/Filtry-App/downloads",
        "issues_url": "https://api.github.com/repos/srijan2498/Filtry-App/issues{/number}",
        "pulls_url": "https://api.github.com/repos/srijan2498/Filtry-App/pulls{/number}",
        "milestones_url": "https://api.github.com/repos/srijan2498/Filtry-App/milestones{/number}",
        "notifications_url": "https://api.github.com/repos/srijan2498/Filtry-App/notifications{?since,all,participating}",
        "labels_url": "https://api.github.com/repos/srijan2498/Filtry-App/labels{/name}",
        "releases_url": "https://api.github.com/repos/srijan2498/Filtry-App/releases{/id}",
        "deployments_url": "https://api.github.com/repos/srijan2498/Filtry-App/deployments",
        "created_at": "2023-02-05T05:13:14Z",
        "updated_at": "2023-02-05T05:17:44Z",
        "pushed_at": "2023-02-05T05:17:41Z",
        "git_url": "git://github.com/srijan2498/Filtry-App.git",
        "ssh_url": "git@github.com:srijan2498/Filtry-App.git",
        "clone_url": "https://github.com/srijan2498/Filtry-App.git",
        "svn_url": "https://github.com/srijan2498/Filtry-App",
        "homepage": null,
        "size": 8094,
        "stargazers_count": 0,
        "watchers_count": 0,
        "language": "JavaScript",
        "has_issues": true,
        "has_projects": true,
        "has_downloads": true,
        "has_wiki": true,
        "has_pages": false,
        "has_discussions": false,
        "forks_count": 0,
        "mirror_url": null,
        "archived": false,
        "disabled": false,
        "open_issues_count": 0,
        "license": null,
        "allow_forking": true,
        "is_template": false,
        "web_commit_signoff_required": false,
        "topics": [

        ],
        "visibility": "public",
        "forks": 0,
        "open_issues": 0,
        "watchers": 0,
        "default_branch": "main"
    },
    {
        "id": 479506897,
        "node_id": "R_kgDOHJSx0Q",
        "name": "Git-Finder",
        "full_name": "srijan2498/Git-Finder",
        "private": false,
        "owner": {
            "login": "srijan2498",
            "id": 47470062,
            "node_id": "MDQ6VXNlcjQ3NDcwMDYy",
            "avatar_url": "https://avatars.githubusercontent.com/u/47470062?v=4",
            "gravatar_id": "",
            "url": "https://api.github.com/users/srijan2498",
            "html_url": "https://github.com/srijan2498",
            "followers_url": "https://api.github.com/users/srijan2498/followers",
            "following_url": "https://api.github.com/users/srijan2498/following{/other_user}",
            "gists_url": "https://api.github.com/users/srijan2498/gists{/gist_id}",
            "starred_url": "https://api.github.com/users/srijan2498/starred{/owner}{/repo}",
            "subscriptions_url": "https://api.github.com/users/srijan2498/subscriptions",
            "organizations_url": "https://api.github.com/users/srijan2498/orgs",
            "repos_url": "https://api.github.com/users/srijan2498/repos",
            "events_url": "https://api.github.com/users/srijan2498/events{/privacy}",
            "received_events_url": "https://api.github.com/users/srijan2498/received_events",
            "type": "User",
            "site_admin": false
        },
        "html_url": "https://github.com/srijan2498/Git-Finder",
        "description": "It is a website which is used to find github profile and repositories of the user by making use of github api. The technologies used here are Html, CSS, JavaScript and jQuery, Ajax.",
        "fork": false,
        "url": "https://api.github.com/repos/srijan2498/Git-Finder",
        "forks_url": "https://api.github.com/repos/srijan2498/Git-Finder/forks",
        "keys_url": "https://api.github.com/repos/srijan2498/Git-Finder/keys{/key_id}",
        "collaborators_url": "https://api.github.com/repos/srijan2498/Git-Finder/collaborators{/collaborator}",
        "teams_url": "https://api.github.com/repos/srijan2498/Git-Finder/teams",
        "hooks_url": "https://api.github.com/repos/srijan2498/Git-Finder/hooks",
        "issue_events_url": "https://api.github.com/repos/srijan2498/Git-Finder/issues/events{/number}",
        "events_url": "https://api.github.com/repos/srijan2498/Git-Finder/events",
        "assignees_url": "https://api.github.com/repos/srijan2498/Git-Finder/assignees{/user}",
        "branches_url": "https://api.github.com/repos/srijan2498/Git-Finder/branches{/branch}",
        "tags_url": "https://api.github.com/repos/srijan2498/Git-Finder/tags",
        "blobs_url": "https://api.github.com/repos/srijan2498/Git-Finder/git/blobs{/sha}",
        "git_tags_url": "https://api.github.com/repos/srijan2498/Git-Finder/git/tags{/sha}",
        "git_refs_url": "https://api.github.com/repos/srijan2498/Git-Finder/git/refs{/sha}",
        "trees_url": "https://api.github.com/repos/srijan2498/Git-Finder/git/trees{/sha}",
        "statuses_url": "https://api.github.com/repos/srijan2498/Git-Finder/statuses/{sha}",
        "languages_url": "https://api.github.com/repos/srijan2498/Git-Finder/languages",
        "stargazers_url": "https://api.github.com/repos/srijan2498/Git-Finder/stargazers",
        "contributors_url": "https://api.github.com/repos/srijan2498/Git-Finder/contributors",
        "subscribers_url": "https://api.github.com/repos/srijan2498/Git-Finder/subscribers",
        "subscription_url": "https://api.github.com/repos/srijan2498/Git-Finder/subscription",
        "commits_url": "https://api.github.com/repos/srijan2498/Git-Finder/commits{/sha}",
        "git_commits_url": "https://api.github.com/repos/srijan2498/Git-Finder/git/commits{/sha}",
        "comments_url": "https://api.github.com/repos/srijan2498/Git-Finder/comments{/number}",
        "issue_comment_url": "https://api.github.com/repos/srijan2498/Git-Finder/issues/comments{/number}",
        "contents_url": "https://api.github.com/repos/srijan2498/Git-Finder/contents/{+path}",
        "compare_url": "https://api.github.com/repos/srijan2498/Git-Finder/compare/{base}...{head}",
        "merges_url": "https://api.github.com/repos/srijan2498/Git-Finder/merges",
        "archive_url": "https://api.github.com/repos/srijan2498/Git-Finder/{archive_format}{/ref}",
        "downloads_url": "https://api.github.com/repos/srijan2498/Git-Finder/downloads",
        "issues_url": "https://api.github.com/repos/srijan2498/Git-Finder/issues{/number}",
        "pulls_url": "https://api.github.com/repos/srijan2498/Git-Finder/pulls{/number}",
        "milestones_url": "https://api.github.com/repos/srijan2498/Git-Finder/milestones{/number}",
        "notifications_url": "https://api.github.com/repos/srijan2498/Git-Finder/notifications{?since,all,participating}",
        "labels_url": "https://api.github.com/repos/srijan2498/Git-Finder/labels{/name}",
        "releases_url": "https://api.github.com/repos/srijan2498/Git-Finder/releases{/id}",
        "deployments_url": "https://api.github.com/repos/srijan2498/Git-Finder/deployments",
        "created_at": "2022-04-08T19:00:04Z",
        "updated_at": "2022-04-08T19:00:34Z",
        "pushed_at": "2022-04-08T19:00:32Z",
        "git_url": "git://github.com/srijan2498/Git-Finder.git",
        "ssh_url": "git@github.com:srijan2498/Git-Finder.git",
        "clone_url": "https://github.com/srijan2498/Git-Finder.git",
        "svn_url": "https://github.com/srijan2498/Git-Finder",
        "homepage": null,
        "size": 4,
        "stargazers_count": 0,
        "watchers_count": 0,
        "language": "JavaScript",
        "has_issues": true,
        "has_projects": true,
        "has_downloads": true,
        "has_wiki": true,
        "has_pages": false,
        "has_discussions": false,
        "forks_count": 0,
        "mirror_url": null,
        "archived": false,
        "disabled": false,
        "open_issues_count": 0,
        "license": null,
        "allow_forking": true,
        "is_template": false,
        "web_commit_signoff_required": false,
        "topics": [

        ],
        "visibility": "public",
        "forks": 0,
        "open_issues": 0,
        "watchers": 0,
        "default_branch": "main"
    },
    {
        "id": 281050620,
        "node_id": "MDEwOlJlcG9zaXRvcnkyODEwNTA2MjA=",
        "name": "Java-Calculator-Application",
        "full_name": "srijan2498/Java-Calculator-Application",
        "private": false,
        "owner": {
            "login": "srijan2498",
            "id": 47470062,
            "node_id": "MDQ6VXNlcjQ3NDcwMDYy",
            "avatar_url": "https://avatars.githubusercontent.com/u/47470062?v=4",
            "gravatar_id": "",
            "url": "https://api.github.com/users/srijan2498",
            "html_url": "https://github.com/srijan2498",
            "followers_url": "https://api.github.com/users/srijan2498/followers",
            "following_url": "https://api.github.com/users/srijan2498/following{/other_user}",
            "gists_url": "https://api.github.com/users/srijan2498/gists{/gist_id}",
            "starred_url": "https://api.github.com/users/srijan2498/starred{/owner}{/repo}",
            "subscriptions_url": "https://api.github.com/users/srijan2498/subscriptions",
            "organizations_url": "https://api.github.com/users/srijan2498/orgs",
            "repos_url": "https://api.github.com/users/srijan2498/repos",
            "events_url": "https://api.github.com/users/srijan2498/events{/privacy}",
            "received_events_url": "https://api.github.com/users/srijan2498/received_events",
            "type": "User",
            "site_admin": false
        },
        "html_url": "https://github.com/srijan2498/Java-Calculator-Application",
        "description": "It is a simple calculator app with proper GUI developed using JAVA as the programming language and NetBeans 8.2 IDE. It consists of all basic math operations like addition, subtraction, multiplication, division, and squaring of a number.",
        "fork": false,
        "url": "https://api.github.com/repos/srijan2498/Java-Calculator-Application",
        "forks_url": "https://api.github.com/repos/srijan2498/Java-Calculator-Application/forks",
        "keys_url": "https://api.github.com/repos/srijan2498/Java-Calculator-Application/keys{/key_id}",
        "collaborators_url": "https://api.github.com/repos/srijan2498/Java-Calculator-Application/collaborators{/collaborator}",
        "teams_url": "https://api.github.com/repos/srijan2498/Java-Calculator-Application/teams",
        "hooks_url": "https://api.github.com/repos/srijan2498/Java-Calculator-Application/hooks",
        "issue_events_url": "https://api.github.com/repos/srijan2498/Java-Calculator-Application/issues/events{/number}",
        "events_url": "https://api.github.com/repos/srijan2498/Java-Calculator-Application/events",
        "assignees_url": "https://api.github.com/repos/srijan2498/Java-Calculator-Application/assignees{/user}",
        "branches_url": "https://api.github.com/repos/srijan2498/Java-Calculator-Application/branches{/branch}",
        "tags_url": "https://api.github.com/repos/srijan2498/Java-Calculator-Application/tags",
        "blobs_url": "https://api.github.com/repos/srijan2498/Java-Calculator-Application/git/blobs{/sha}",
        "git_tags_url": "https://api.github.com/repos/srijan2498/Java-Calculator-Application/git/tags{/sha}",
        "git_refs_url": "https://api.github.com/repos/srijan2498/Java-Calculator-Application/git/refs{/sha}",
        "trees_url": "https://api.github.com/repos/srijan2498/Java-Calculator-Application/git/trees{/sha}",
        "statuses_url": "https://api.github.com/repos/srijan2498/Java-Calculator-Application/statuses/{sha}",
        "languages_url": "https://api.github.com/repos/srijan2498/Java-Calculator-Application/languages",
        "stargazers_url": "https://api.github.com/repos/srijan2498/Java-Calculator-Application/stargazers",
        "contributors_url": "https://api.github.com/repos/srijan2498/Java-Calculator-Application/contributors",
        "subscribers_url": "https://api.github.com/repos/srijan2498/Java-Calculator-Application/subscribers",
        "subscription_url": "https://api.github.com/repos/srijan2498/Java-Calculator-Application/subscription",
        "commits_url": "https://api.github.com/repos/srijan2498/Java-Calculator-Application/commits{/sha}",
        "git_commits_url": "https://api.github.com/repos/srijan2498/Java-Calculator-Application/git/commits{/sha}",
        "comments_url": "https://api.github.com/repos/srijan2498/Java-Calculator-Application/comments{/number}",
        "issue_comment_url": "https://api.github.com/repos/srijan2498/Java-Calculator-Application/issues/comments{/number}",
        "contents_url": "https://api.github.com/repos/srijan2498/Java-Calculator-Application/contents/{+path}",
        "compare_url": "https://api.github.com/repos/srijan2498/Java-Calculator-Application/compare/{base}...{head}",
        "merges_url": "https://api.github.com/repos/srijan2498/Java-Calculator-Application/merges",
        "archive_url": "https://api.github.com/repos/srijan2498/Java-Calculator-Application/{archive_format}{/ref}",
        "downloads_url": "https://api.github.com/repos/srijan2498/Java-Calculator-Application/downloads",
        "issues_url": "https://api.github.com/repos/srijan2498/Java-Calculator-Application/issues{/number}",
        "pulls_url": "https://api.github.com/repos/srijan2498/Java-Calculator-Application/pulls{/number}",
        "milestones_url": "https://api.github.com/repos/srijan2498/Java-Calculator-Application/milestones{/number}",
        "notifications_url": "https://api.github.com/repos/srijan2498/Java-Calculator-Application/notifications{?since,all,participating}",
        "labels_url": "https://api.github.com/repos/srijan2498/Java-Calculator-Application/labels{/name}",
        "releases_url": "https://api.github.com/repos/srijan2498/Java-Calculator-Application/releases{/id}",
        "deployments_url": "https://api.github.com/repos/srijan2498/Java-Calculator-Application/deployments",
        "created_at": "2020-07-20T07:49:34Z",
        "updated_at": "2020-07-20T07:59:21Z",
        "pushed_at": "2020-07-20T07:59:19Z",
        "git_url": "git://github.com/srijan2498/Java-Calculator-Application.git",
        "ssh_url": "git@github.com:srijan2498/Java-Calculator-Application.git",
        "clone_url": "https://github.com/srijan2498/Java-Calculator-Application.git",
        "svn_url": "https://github.com/srijan2498/Java-Calculator-Application",
        "homepage": null,
        "size": 58,
        "stargazers_count": 0,
        "watchers_count": 0,
        "language": "Java",
        "has_issues": true,
        "has_projects": true,
        "has_downloads": true,
        "has_wiki": true,
        "has_pages": false,
        "has_discussions": false,
        "forks_count": 0,
        "mirror_url": null,
        "archived": false,
        "disabled": false,
        "open_issues_count": 0,
        "license": null,
        "allow_forking": true,
        "is_template": false,
        "web_commit_signoff_required": false,
        "topics": [

        ],
        "visibility": "public",
        "forks": 0,
        "open_issues": 0,
        "watchers": 0,
        "default_branch": "master"
    },
    {
        "id": 515937618,
        "node_id": "R_kgDOHsCVUg",
        "name": "JavaScript-Calculator",
        "full_name": "srijan2498/JavaScript-Calculator",
        "private": false,
        "owner": {
            "login": "srijan2498",
            "id": 47470062,
            "node_id": "MDQ6VXNlcjQ3NDcwMDYy",
            "avatar_url": "https://avatars.githubusercontent.com/u/47470062?v=4",
            "gravatar_id": "",
            "url": "https://api.github.com/users/srijan2498",
            "html_url": "https://github.com/srijan2498",
            "followers_url": "https://api.github.com/users/srijan2498/followers",
            "following_url": "https://api.github.com/users/srijan2498/following{/other_user}",
            "gists_url": "https://api.github.com/users/srijan2498/gists{/gist_id}",
            "starred_url": "https://api.github.com/users/srijan2498/starred{/owner}{/repo}",
            "subscriptions_url": "https://api.github.com/users/srijan2498/subscriptions",
            "organizations_url": "https://api.github.com/users/srijan2498/orgs",
            "repos_url": "https://api.github.com/users/srijan2498/repos",
            "events_url": "https://api.github.com/users/srijan2498/events{/privacy}",
            "received_events_url": "https://api.github.com/users/srijan2498/received_events",
            "type": "User",
            "site_admin": false
        },
        "html_url": "https://github.com/srijan2498/JavaScript-Calculator",
        "description": "It is a basic calculator web-app with a clean UI. It is developed using HTML, CSS, JavaScript.",
        "fork": false,
        "url": "https://api.github.com/repos/srijan2498/JavaScript-Calculator",
        "forks_url": "https://api.github.com/repos/srijan2498/JavaScript-Calculator/forks",
        "keys_url": "https://api.github.com/repos/srijan2498/JavaScript-Calculator/keys{/key_id}",
        "collaborators_url": "https://api.github.com/repos/srijan2498/JavaScript-Calculator/collaborators{/collaborator}",
        "teams_url": "https://api.github.com/repos/srijan2498/JavaScript-Calculator/teams",
        "hooks_url": "https://api.github.com/repos/srijan2498/JavaScript-Calculator/hooks",
        "issue_events_url": "https://api.github.com/repos/srijan2498/JavaScript-Calculator/issues/events{/number}",
        "events_url": "https://api.github.com/repos/srijan2498/JavaScript-Calculator/events",
        "assignees_url": "https://api.github.com/repos/srijan2498/JavaScript-Calculator/assignees{/user}",
        "branches_url": "https://api.github.com/repos/srijan2498/JavaScript-Calculator/branches{/branch}",
        "tags_url": "https://api.github.com/repos/srijan2498/JavaScript-Calculator/tags",
        "blobs_url": "https://api.github.com/repos/srijan2498/JavaScript-Calculator/git/blobs{/sha}",
        "git_tags_url": "https://api.github.com/repos/srijan2498/JavaScript-Calculator/git/tags{/sha}",
        "git_refs_url": "https://api.github.com/repos/srijan2498/JavaScript-Calculator/git/refs{/sha}",
        "trees_url": "https://api.github.com/repos/srijan2498/JavaScript-Calculator/git/trees{/sha}",
        "statuses_url": "https://api.github.com/repos/srijan2498/JavaScript-Calculator/statuses/{sha}",
        "languages_url": "https://api.github.com/repos/srijan2498/JavaScript-Calculator/languages",
        "stargazers_url": "https://api.github.com/repos/srijan2498/JavaScript-Calculator/stargazers",
        "contributors_url": "https://api.github.com/repos/srijan2498/JavaScript-Calculator/contributors",
        "subscribers_url": "https://api.github.com/repos/srijan2498/JavaScript-Calculator/subscribers",
        "subscription_url": "https://api.github.com/repos/srijan2498/JavaScript-Calculator/subscription",
        "commits_url": "https://api.github.com/repos/srijan2498/JavaScript-Calculator/commits{/sha}",
        "git_commits_url": "https://api.github.com/repos/srijan2498/JavaScript-Calculator/git/commits{/sha}",
        "comments_url": "https://api.github.com/repos/srijan2498/JavaScript-Calculator/comments{/number}",
        "issue_comment_url": "https://api.github.com/repos/srijan2498/JavaScript-Calculator/issues/comments{/number}",
        "contents_url": "https://api.github.com/repos/srijan2498/JavaScript-Calculator/contents/{+path}",
        "compare_url": "https://api.github.com/repos/srijan2498/JavaScript-Calculator/compare/{base}...{head}",
        "merges_url": "https://api.github.com/repos/srijan2498/JavaScript-Calculator/merges",
        "archive_url": "https://api.github.com/repos/srijan2498/JavaScript-Calculator/{archive_format}{/ref}",
        "downloads_url": "https://api.github.com/repos/srijan2498/JavaScript-Calculator/downloads",
        "issues_url": "https://api.github.com/repos/srijan2498/JavaScript-Calculator/issues{/number}",
        "pulls_url": "https://api.github.com/repos/srijan2498/JavaScript-Calculator/pulls{/number}",
        "milestones_url": "https://api.github.com/repos/srijan2498/JavaScript-Calculator/milestones{/number}",
        "notifications_url": "https://api.github.com/repos/srijan2498/JavaScript-Calculator/notifications{?since,all,participating}",
        "labels_url": "https://api.github.com/repos/srijan2498/JavaScript-Calculator/labels{/name}",
        "releases_url": "https://api.github.com/repos/srijan2498/JavaScript-Calculator/releases{/id}",
        "deployments_url": "https://api.github.com/repos/srijan2498/JavaScript-Calculator/deployments",
        "created_at": "2022-07-20T10:33:55Z",
        "updated_at": "2022-07-20T10:35:13Z",
        "pushed_at": "2022-07-20T10:35:10Z",
        "git_url": "git://github.com/srijan2498/JavaScript-Calculator.git",
        "ssh_url": "git@github.com:srijan2498/JavaScript-Calculator.git",
        "clone_url": "https://github.com/srijan2498/JavaScript-Calculator.git",
        "svn_url": "https://github.com/srijan2498/JavaScript-Calculator",
        "homepage": null,
        "size": 3,
        "stargazers_count": 0,
        "watchers_count": 0,
        "language": "HTML",
        "has_issues": true,
        "has_projects": true,
        "has_downloads": true,
        "has_wiki": true,
        "has_pages": false,
        "has_discussions": false,
        "forks_count": 0,
        "mirror_url": null,
        "archived": false,
        "disabled": false,
        "open_issues_count": 0,
        "license": null,
        "allow_forking": true,
        "is_template": false,
        "web_commit_signoff_required": false,
        "topics": [

        ],
        "visibility": "public",
        "forks": 0,
        "open_issues": 0,
        "watchers": 0,
        "default_branch": "main"
    },
    {
        "id": 542438490,
        "node_id": "R_kgDOIFT0Wg",
        "name": "keeper",
        "full_name": "srijan2498/keeper",
        "private": false,
        "owner": {
            "login": "srijan2498",
            "id": 47470062,
            "node_id": "MDQ6VXNlcjQ3NDcwMDYy",
            "avatar_url": "https://avatars.githubusercontent.com/u/47470062?v=4",
            "gravatar_id": "",
            "url": "https://api.github.com/users/srijan2498",
            "html_url": "https://github.com/srijan2498",
            "followers_url": "https://api.github.com/users/srijan2498/followers",
            "following_url": "https://api.github.com/users/srijan2498/following{/other_user}",
            "gists_url": "https://api.github.com/users/srijan2498/gists{/gist_id}",
            "starred_url": "https://api.github.com/users/srijan2498/starred{/owner}{/repo}",
            "subscriptions_url": "https://api.github.com/users/srijan2498/subscriptions",
            "organizations_url": "https://api.github.com/users/srijan2498/orgs",
            "repos_url": "https://api.github.com/users/srijan2498/repos",
            "events_url": "https://api.github.com/users/srijan2498/events{/privacy}",
            "received_events_url": "https://api.github.com/users/srijan2498/received_events",
            "type": "User",
            "site_admin": false
        },
        "html_url": "https://github.com/srijan2498/keeper",
        "description": null,
        "fork": false,
        "url": "https://api.github.com/repos/srijan2498/keeper",
        "forks_url": "https://api.github.com/repos/srijan2498/keeper/forks",
        "keys_url": "https://api.github.com/repos/srijan2498/keeper/keys{/key_id}",
        "collaborators_url": "https://api.github.com/repos/srijan2498/keeper/collaborators{/collaborator}",
        "teams_url": "https://api.github.com/repos/srijan2498/keeper/teams",
        "hooks_url": "https://api.github.com/repos/srijan2498/keeper/hooks",
        "issue_events_url": "https://api.github.com/repos/srijan2498/keeper/issues/events{/number}",
        "events_url": "https://api.github.com/repos/srijan2498/keeper/events",
        "assignees_url": "https://api.github.com/repos/srijan2498/keeper/assignees{/user}",
        "branches_url": "https://api.github.com/repos/srijan2498/keeper/branches{/branch}",
        "tags_url": "https://api.github.com/repos/srijan2498/keeper/tags",
        "blobs_url": "https://api.github.com/repos/srijan2498/keeper/git/blobs{/sha}",
        "git_tags_url": "https://api.github.com/repos/srijan2498/keeper/git/tags{/sha}",
        "git_refs_url": "https://api.github.com/repos/srijan2498/keeper/git/refs{/sha}",
        "trees_url": "https://api.github.com/repos/srijan2498/keeper/git/trees{/sha}",
        "statuses_url": "https://api.github.com/repos/srijan2498/keeper/statuses/{sha}",
        "languages_url": "https://api.github.com/repos/srijan2498/keeper/languages",
        "stargazers_url": "https://api.github.com/repos/srijan2498/keeper/stargazers",
        "contributors_url": "https://api.github.com/repos/srijan2498/keeper/contributors",
        "subscribers_url": "https://api.github.com/repos/srijan2498/keeper/subscribers",
        "subscription_url": "https://api.github.com/repos/srijan2498/keeper/subscription",
        "commits_url": "https://api.github.com/repos/srijan2498/keeper/commits{/sha}",
        "git_commits_url": "https://api.github.com/repos/srijan2498/keeper/git/commits{/sha}",
        "comments_url": "https://api.github.com/repos/srijan2498/keeper/comments{/number}",
        "issue_comment_url": "https://api.github.com/repos/srijan2498/keeper/issues/comments{/number}",
        "contents_url": "https://api.github.com/repos/srijan2498/keeper/contents/{+path}",
        "compare_url": "https://api.github.com/repos/srijan2498/keeper/compare/{base}...{head}",
        "merges_url": "https://api.github.com/repos/srijan2498/keeper/merges",
        "archive_url": "https://api.github.com/repos/srijan2498/keeper/{archive_format}{/ref}",
        "downloads_url": "https://api.github.com/repos/srijan2498/keeper/downloads",
        "issues_url": "https://api.github.com/repos/srijan2498/keeper/issues{/number}",
        "pulls_url": "https://api.github.com/repos/srijan2498/keeper/pulls{/number}",
        "milestones_url": "https://api.github.com/repos/srijan2498/keeper/milestones{/number}",
        "notifications_url": "https://api.github.com/repos/srijan2498/keeper/notifications{?since,all,participating}",
        "labels_url": "https://api.github.com/repos/srijan2498/keeper/labels{/name}",
        "releases_url": "https://api.github.com/repos/srijan2498/keeper/releases{/id}",
        "deployments_url": "https://api.github.com/repos/srijan2498/keeper/deployments",
        "created_at": "2022-09-28T06:21:25Z",
        "updated_at": "2022-09-28T06:25:47Z",
        "pushed_at": "2022-09-28T06:25:43Z",
        "git_url": "git://github.com/srijan2498/keeper.git",
        "ssh_url": "git@github.com:srijan2498/keeper.git",
        "clone_url": "https://github.com/srijan2498/keeper.git",
        "svn_url": "https://github.com/srijan2498/keeper",
        "homepage": null,
        "size": 433,
        "stargazers_count": 0,
        "watchers_count": 0,
        "language": "JavaScript",
        "has_issues": true,
        "has_projects": true,
        "has_downloads": true,
        "has_wiki": true,
        "has_pages": false,
        "has_discussions": false,
        "forks_count": 0,
        "mirror_url": null,
        "archived": false,
        "disabled": false,
        "open_issues_count": 0,
        "license": null,
        "allow_forking": true,
        "is_template": false,
        "web_commit_signoff_required": false,
        "topics": [

        ],
        "visibility": "public",
        "forks": 0,
        "open_issues": 0,
        "watchers": 0,
        "default_branch": "main"
    },
    {
        "id": 377760845,
        "node_id": "MDEwOlJlcG9zaXRvcnkzNzc3NjA4NDU=",
        "name": "Leetcode-Solution",
        "full_name": "srijan2498/Leetcode-Solution",
        "private": false,
        "owner": {
            "login": "srijan2498",
            "id": 47470062,
            "node_id": "MDQ6VXNlcjQ3NDcwMDYy",
            "avatar_url": "https://avatars.githubusercontent.com/u/47470062?v=4",
            "gravatar_id": "",
            "url": "https://api.github.com/users/srijan2498",
            "html_url": "https://github.com/srijan2498",
            "followers_url": "https://api.github.com/users/srijan2498/followers",
            "following_url": "https://api.github.com/users/srijan2498/following{/other_user}",
            "gists_url": "https://api.github.com/users/srijan2498/gists{/gist_id}",
            "starred_url": "https://api.github.com/users/srijan2498/starred{/owner}{/repo}",
            "subscriptions_url": "https://api.github.com/users/srijan2498/subscriptions",
            "organizations_url": "https://api.github.com/users/srijan2498/orgs",
            "repos_url": "https://api.github.com/users/srijan2498/repos",
            "events_url": "https://api.github.com/users/srijan2498/events{/privacy}",
            "received_events_url": "https://api.github.com/users/srijan2498/received_events",
            "type": "User",
            "site_admin": false
        },
        "html_url": "https://github.com/srijan2498/Leetcode-Solution",
        "description": null,
        "fork": false,
        "url": "https://api.github.com/repos/srijan2498/Leetcode-Solution",
        "forks_url": "https://api.github.com/repos/srijan2498/Leetcode-Solution/forks",
        "keys_url": "https://api.github.com/repos/srijan2498/Leetcode-Solution/keys{/key_id}",
        "collaborators_url": "https://api.github.com/repos/srijan2498/Leetcode-Solution/collaborators{/collaborator}",
        "teams_url": "https://api.github.com/repos/srijan2498/Leetcode-Solution/teams",
        "hooks_url": "https://api.github.com/repos/srijan2498/Leetcode-Solution/hooks",
        "issue_events_url": "https://api.github.com/repos/srijan2498/Leetcode-Solution/issues/events{/number}",
        "events_url": "https://api.github.com/repos/srijan2498/Leetcode-Solution/events",
        "assignees_url": "https://api.github.com/repos/srijan2498/Leetcode-Solution/assignees{/user}",
        "branches_url": "https://api.github.com/repos/srijan2498/Leetcode-Solution/branches{/branch}",
        "tags_url": "https://api.github.com/repos/srijan2498/Leetcode-Solution/tags",
        "blobs_url": "https://api.github.com/repos/srijan2498/Leetcode-Solution/git/blobs{/sha}",
        "git_tags_url": "https://api.github.com/repos/srijan2498/Leetcode-Solution/git/tags{/sha}",
        "git_refs_url": "https://api.github.com/repos/srijan2498/Leetcode-Solution/git/refs{/sha}",
        "trees_url": "https://api.github.com/repos/srijan2498/Leetcode-Solution/git/trees{/sha}",
        "statuses_url": "https://api.github.com/repos/srijan2498/Leetcode-Solution/statuses/{sha}",
        "languages_url": "https://api.github.com/repos/srijan2498/Leetcode-Solution/languages",
        "stargazers_url": "https://api.github.com/repos/srijan2498/Leetcode-Solution/stargazers",
        "contributors_url": "https://api.github.com/repos/srijan2498/Leetcode-Solution/contributors",
        "subscribers_url": "https://api.github.com/repos/srijan2498/Leetcode-Solution/subscribers",
        "subscription_url": "https://api.github.com/repos/srijan2498/Leetcode-Solution/subscription",
        "commits_url": "https://api.github.com/repos/srijan2498/Leetcode-Solution/commits{/sha}",
        "git_commits_url": "https://api.github.com/repos/srijan2498/Leetcode-Solution/git/commits{/sha}",
        "comments_url": "https://api.github.com/repos/srijan2498/Leetcode-Solution/comments{/number}",
        "issue_comment_url": "https://api.github.com/repos/srijan2498/Leetcode-Solution/issues/comments{/number}",
        "contents_url": "https://api.github.com/repos/srijan2498/Leetcode-Solution/contents/{+path}",
        "compare_url": "https://api.github.com/repos/srijan2498/Leetcode-Solution/compare/{base}...{head}",
        "merges_url": "https://api.github.com/repos/srijan2498/Leetcode-Solution/merges",
        "archive_url": "https://api.github.com/repos/srijan2498/Leetcode-Solution/{archive_format}{/ref}",
        "downloads_url": "https://api.github.com/repos/srijan2498/Leetcode-Solution/downloads",
        "issues_url": "https://api.github.com/repos/srijan2498/Leetcode-Solution/issues{/number}",
        "pulls_url": "https://api.github.com/repos/srijan2498/Leetcode-Solution/pulls{/number}",
        "milestones_url": "https://api.github.com/repos/srijan2498/Leetcode-Solution/milestones{/number}",
        "notifications_url": "https://api.github.com/repos/srijan2498/Leetcode-Solution/notifications{?since,all,participating}",
        "labels_url": "https://api.github.com/repos/srijan2498/Leetcode-Solution/labels{/name}",
        "releases_url": "https://api.github.com/repos/srijan2498/Leetcode-Solution/releases{/id}",
        "deployments_url": "https://api.github.com/repos/srijan2498/Leetcode-Solution/deployments",
        "created_at": "2021-06-17T08:35:27Z",
        "updated_at": "2021-06-19T14:17:54Z",
        "pushed_at": "2021-06-19T14:17:52Z",
        "git_url": "git://github.com/srijan2498/Leetcode-Solution.git",
        "ssh_url": "git@github.com:srijan2498/Leetcode-Solution.git",
        "clone_url": "https://github.com/srijan2498/Leetcode-Solution.git",
        "svn_url": "https://github.com/srijan2498/Leetcode-Solution",
        "homepage": null,
        "size": 4,
        "stargazers_count": 0,
        "watchers_count": 0,
        "language": null,
        "has_issues": true,
        "has_projects": true,
        "has_downloads": true,
        "has_wiki": true,
        "has_pages": false,
        "has_discussions": false,
        "forks_count": 0,
        "mirror_url": null,
        "archived": false,
        "disabled": false,
        "open_issues_count": 0,
        "license": null,
        "allow_forking": true,
        "is_template": false,
        "web_commit_signoff_required": false,
        "topics": [

        ],
        "visibility": "public",
        "forks": 0,
        "open_issues": 0,
        "watchers": 0,
        "default_branch": "main"
    },
    {
        "id": 479507559,
        "node_id": "R_kgDOHJS0Zw",
        "name": "MSDB",
        "full_name": "srijan2498/MSDB",
        "private": false,
        "owner": {
            "login": "srijan2498",
            "id": 47470062,
            "node_id": "MDQ6VXNlcjQ3NDcwMDYy",
            "avatar_url": "https://avatars.githubusercontent.com/u/47470062?v=4",
            "gravatar_id": "",
            "url": "https://api.github.com/users/srijan2498",
            "html_url": "https://github.com/srijan2498",
            "followers_url": "https://api.github.com/users/srijan2498/followers",
            "following_url": "https://api.github.com/users/srijan2498/following{/other_user}",
            "gists_url": "https://api.github.com/users/srijan2498/gists{/gist_id}",
            "starred_url": "https://api.github.com/users/srijan2498/starred{/owner}{/repo}",
            "subscriptions_url": "https://api.github.com/users/srijan2498/subscriptions",
            "organizations_url": "https://api.github.com/users/srijan2498/orgs",
            "repos_url": "https://api.github.com/users/srijan2498/repos",
            "events_url": "https://api.github.com/users/srijan2498/events{/privacy}",
            "received_events_url": "https://api.github.com/users/srijan2498/received_events",
            "type": "User",
            "site_admin": false
        },
        "html_url": "https://github.com/srijan2498/MSDB",
        "description": "It is a React.js based web application which uses OMDB api to render all the info related to the movie. In this web application I've made use of technologies like React.js, Basic Bootstrap, Basic JSX.",
        "fork": false,
        "url": "https://api.github.com/repos/srijan2498/MSDB",
        "forks_url": "https://api.github.com/repos/srijan2498/MSDB/forks",
        "keys_url": "https://api.github.com/repos/srijan2498/MSDB/keys{/key_id}",
        "collaborators_url": "https://api.github.com/repos/srijan2498/MSDB/collaborators{/collaborator}",
        "teams_url": "https://api.github.com/repos/srijan2498/MSDB/teams",
        "hooks_url": "https://api.github.com/repos/srijan2498/MSDB/hooks",
        "issue_events_url": "https://api.github.com/repos/srijan2498/MSDB/issues/events{/number}",
        "events_url": "https://api.github.com/repos/srijan2498/MSDB/events",
        "assignees_url": "https://api.github.com/repos/srijan2498/MSDB/assignees{/user}",
        "branches_url": "https://api.github.com/repos/srijan2498/MSDB/branches{/branch}",
        "tags_url": "https://api.github.com/repos/srijan2498/MSDB/tags",
        "blobs_url": "https://api.github.com/repos/srijan2498/MSDB/git/blobs{/sha}",
        "git_tags_url": "https://api.github.com/repos/srijan2498/MSDB/git/tags{/sha}",
        "git_refs_url": "https://api.github.com/repos/srijan2498/MSDB/git/refs{/sha}",
        "trees_url": "https://api.github.com/repos/srijan2498/MSDB/git/trees{/sha}",
        "statuses_url": "https://api.github.com/repos/srijan2498/MSDB/statuses/{sha}",
        "languages_url": "https://api.github.com/repos/srijan2498/MSDB/languages",
        "stargazers_url": "https://api.github.com/repos/srijan2498/MSDB/stargazers",
        "contributors_url": "https://api.github.com/repos/srijan2498/MSDB/contributors",
        "subscribers_url": "https://api.github.com/repos/srijan2498/MSDB/subscribers",
        "subscription_url": "https://api.github.com/repos/srijan2498/MSDB/subscription",
        "commits_url": "https://api.github.com/repos/srijan2498/MSDB/commits{/sha}",
        "git_commits_url": "https://api.github.com/repos/srijan2498/MSDB/git/commits{/sha}",
        "comments_url": "https://api.github.com/repos/srijan2498/MSDB/comments{/number}",
        "issue_comment_url": "https://api.github.com/repos/srijan2498/MSDB/issues/comments{/number}",
        "contents_url": "https://api.github.com/repos/srijan2498/MSDB/contents/{+path}",
        "compare_url": "https://api.github.com/repos/srijan2498/MSDB/compare/{base}...{head}",
        "merges_url": "https://api.github.com/repos/srijan2498/MSDB/merges",
        "archive_url": "https://api.github.com/repos/srijan2498/MSDB/{archive_format}{/ref}",
        "downloads_url": "https://api.github.com/repos/srijan2498/MSDB/downloads",
        "issues_url": "https://api.github.com/repos/srijan2498/MSDB/issues{/number}",
        "pulls_url": "https://api.github.com/repos/srijan2498/MSDB/pulls{/number}",
        "milestones_url": "https://api.github.com/repos/srijan2498/MSDB/milestones{/number}",
        "notifications_url": "https://api.github.com/repos/srijan2498/MSDB/notifications{?since,all,participating}",
        "labels_url": "https://api.github.com/repos/srijan2498/MSDB/labels{/name}",
        "releases_url": "https://api.github.com/repos/srijan2498/MSDB/releases{/id}",
        "deployments_url": "https://api.github.com/repos/srijan2498/MSDB/deployments",
        "created_at": "2022-04-08T19:02:18Z",
        "updated_at": "2022-04-08T19:02:18Z",
        "pushed_at": "2022-04-08T19:02:19Z",
        "git_url": "git://github.com/srijan2498/MSDB.git",
        "ssh_url": "git@github.com:srijan2498/MSDB.git",
        "clone_url": "https://github.com/srijan2498/MSDB.git",
        "svn_url": "https://github.com/srijan2498/MSDB",
        "homepage": null,
        "size": 0,
        "stargazers_count": 0,
        "watchers_count": 0,
        "language": null,
        "has_issues": true,
        "has_projects": true,
        "has_downloads": true,
        "has_wiki": true,
        "has_pages": false,
        "has_discussions": false,
        "forks_count": 0,
        "mirror_url": null,
        "archived": false,
        "disabled": false,
        "open_issues_count": 0,
        "license": null,
        "allow_forking": true,
        "is_template": false,
        "web_commit_signoff_required": false,
        "topics": [

        ],
        "visibility": "public",
        "forks": 0,
        "open_issues": 0,
        "watchers": 0,
        "default_branch": "main"
    },
    {
        "id": 597774197,
        "node_id": "R_kgDOI6FPdQ",
        "name": "News-Hunt",
        "full_name": "srijan2498/News-Hunt",
        "private": false,
        "owner": {
            "login": "srijan2498",
            "id": 47470062,
            "node_id": "MDQ6VXNlcjQ3NDcwMDYy",
            "avatar_url": "https://avatars.githubusercontent.com/u/47470062?v=4",
            "gravatar_id": "",
            "url": "https://api.github.com/users/srijan2498",
            "html_url": "https://github.com/srijan2498",
            "followers_url": "https://api.github.com/users/srijan2498/followers",
            "following_url": "https://api.github.com/users/srijan2498/following{/other_user}",
            "gists_url": "https://api.github.com/users/srijan2498/gists{/gist_id}",
            "starred_url": "https://api.github.com/users/srijan2498/starred{/owner}{/repo}",
            "subscriptions_url": "https://api.github.com/users/srijan2498/subscriptions",
            "organizations_url": "https://api.github.com/users/srijan2498/orgs",
            "repos_url": "https://api.github.com/users/srijan2498/repos",
            "events_url": "https://api.github.com/users/srijan2498/events{/privacy}",
            "received_events_url": "https://api.github.com/users/srijan2498/received_events",
            "type": "User",
            "site_admin": false
        },
        "html_url": "https://github.com/srijan2498/News-Hunt",
        "description": "It is a react based web application which can help the user to get their daily dose of news and keep themselves updated about the world around them.",
        "fork": false,
        "url": "https://api.github.com/repos/srijan2498/News-Hunt",
        "forks_url": "https://api.github.com/repos/srijan2498/News-Hunt/forks",
        "keys_url": "https://api.github.com/repos/srijan2498/News-Hunt/keys{/key_id}",
        "collaborators_url": "https://api.github.com/repos/srijan2498/News-Hunt/collaborators{/collaborator}",
        "teams_url": "https://api.github.com/repos/srijan2498/News-Hunt/teams",
        "hooks_url": "https://api.github.com/repos/srijan2498/News-Hunt/hooks",
        "issue_events_url": "https://api.github.com/repos/srijan2498/News-Hunt/issues/events{/number}",
        "events_url": "https://api.github.com/repos/srijan2498/News-Hunt/events",
        "assignees_url": "https://api.github.com/repos/srijan2498/News-Hunt/assignees{/user}",
        "branches_url": "https://api.github.com/repos/srijan2498/News-Hunt/branches{/branch}",
        "tags_url": "https://api.github.com/repos/srijan2498/News-Hunt/tags",
        "blobs_url": "https://api.github.com/repos/srijan2498/News-Hunt/git/blobs{/sha}",
        "git_tags_url": "https://api.github.com/repos/srijan2498/News-Hunt/git/tags{/sha}",
        "git_refs_url": "https://api.github.com/repos/srijan2498/News-Hunt/git/refs{/sha}",
        "trees_url": "https://api.github.com/repos/srijan2498/News-Hunt/git/trees{/sha}",
        "statuses_url": "https://api.github.com/repos/srijan2498/News-Hunt/statuses/{sha}",
        "languages_url": "https://api.github.com/repos/srijan2498/News-Hunt/languages",
        "stargazers_url": "https://api.github.com/repos/srijan2498/News-Hunt/stargazers",
        "contributors_url": "https://api.github.com/repos/srijan2498/News-Hunt/contributors",
        "subscribers_url": "https://api.github.com/repos/srijan2498/News-Hunt/subscribers",
        "subscription_url": "https://api.github.com/repos/srijan2498/News-Hunt/subscription",
        "commits_url": "https://api.github.com/repos/srijan2498/News-Hunt/commits{/sha}",
        "git_commits_url": "https://api.github.com/repos/srijan2498/News-Hunt/git/commits{/sha}",
        "comments_url": "https://api.github.com/repos/srijan2498/News-Hunt/comments{/number}",
        "issue_comment_url": "https://api.github.com/repos/srijan2498/News-Hunt/issues/comments{/number}",
        "contents_url": "https://api.github.com/repos/srijan2498/News-Hunt/contents/{+path}",
        "compare_url": "https://api.github.com/repos/srijan2498/News-Hunt/compare/{base}...{head}",
        "merges_url": "https://api.github.com/repos/srijan2498/News-Hunt/merges",
        "archive_url": "https://api.github.com/repos/srijan2498/News-Hunt/{archive_format}{/ref}",
        "downloads_url": "https://api.github.com/repos/srijan2498/News-Hunt/downloads",
        "issues_url": "https://api.github.com/repos/srijan2498/News-Hunt/issues{/number}",
        "pulls_url": "https://api.github.com/repos/srijan2498/News-Hunt/pulls{/number}",
        "milestones_url": "https://api.github.com/repos/srijan2498/News-Hunt/milestones{/number}",
        "notifications_url": "https://api.github.com/repos/srijan2498/News-Hunt/notifications{?since,all,participating}",
        "labels_url": "https://api.github.com/repos/srijan2498/News-Hunt/labels{/name}",
        "releases_url": "https://api.github.com/repos/srijan2498/News-Hunt/releases{/id}",
        "deployments_url": "https://api.github.com/repos/srijan2498/News-Hunt/deployments",
        "created_at": "2023-02-05T15:51:56Z",
        "updated_at": "2023-02-05T16:14:32Z",
        "pushed_at": "2023-02-05T16:14:28Z",
        "git_url": "git://github.com/srijan2498/News-Hunt.git",
        "ssh_url": "git@github.com:srijan2498/News-Hunt.git",
        "clone_url": "https://github.com/srijan2498/News-Hunt.git",
        "svn_url": "https://github.com/srijan2498/News-Hunt",
        "homepage": null,
        "size": 336,
        "stargazers_count": 0,
        "watchers_count": 0,
        "language": "JavaScript",
        "has_issues": true,
        "has_projects": true,
        "has_downloads": true,
        "has_wiki": true,
        "has_pages": false,
        "has_discussions": false,
        "forks_count": 0,
        "mirror_url": null,
        "archived": false,
        "disabled": false,
        "open_issues_count": 0,
        "license": null,
        "allow_forking": true,
        "is_template": false,
        "web_commit_signoff_required": false,
        "topics": [

        ],
        "visibility": "public",
        "forks": 0,
        "open_issues": 0,
        "watchers": 0,
        "default_branch": "main"
    },
    {
        "id": 473728835,
        "node_id": "R_kgDOHDyHQw",
        "name": "Resume_march_2022",
        "full_name": "srijan2498/Resume_march_2022",
        "private": false,
        "owner": {
            "login": "srijan2498",
            "id": 47470062,
            "node_id": "MDQ6VXNlcjQ3NDcwMDYy",
            "avatar_url": "https://avatars.githubusercontent.com/u/47470062?v=4",
            "gravatar_id": "",
            "url": "https://api.github.com/users/srijan2498",
            "html_url": "https://github.com/srijan2498",
            "followers_url": "https://api.github.com/users/srijan2498/followers",
            "following_url": "https://api.github.com/users/srijan2498/following{/other_user}",
            "gists_url": "https://api.github.com/users/srijan2498/gists{/gist_id}",
            "starred_url": "https://api.github.com/users/srijan2498/starred{/owner}{/repo}",
            "subscriptions_url": "https://api.github.com/users/srijan2498/subscriptions",
            "organizations_url": "https://api.github.com/users/srijan2498/orgs",
            "repos_url": "https://api.github.com/users/srijan2498/repos",
            "events_url": "https://api.github.com/users/srijan2498/events{/privacy}",
            "received_events_url": "https://api.github.com/users/srijan2498/received_events",
            "type": "User",
            "site_admin": false
        },
        "html_url": "https://github.com/srijan2498/Resume_march_2022",
        "description": null,
        "fork": false,
        "url": "https://api.github.com/repos/srijan2498/Resume_march_2022",
        "forks_url": "https://api.github.com/repos/srijan2498/Resume_march_2022/forks",
        "keys_url": "https://api.github.com/repos/srijan2498/Resume_march_2022/keys{/key_id}",
        "collaborators_url": "https://api.github.com/repos/srijan2498/Resume_march_2022/collaborators{/collaborator}",
        "teams_url": "https://api.github.com/repos/srijan2498/Resume_march_2022/teams",
        "hooks_url": "https://api.github.com/repos/srijan2498/Resume_march_2022/hooks",
        "issue_events_url": "https://api.github.com/repos/srijan2498/Resume_march_2022/issues/events{/number}",
        "events_url": "https://api.github.com/repos/srijan2498/Resume_march_2022/events",
        "assignees_url": "https://api.github.com/repos/srijan2498/Resume_march_2022/assignees{/user}",
        "branches_url": "https://api.github.com/repos/srijan2498/Resume_march_2022/branches{/branch}",
        "tags_url": "https://api.github.com/repos/srijan2498/Resume_march_2022/tags",
        "blobs_url": "https://api.github.com/repos/srijan2498/Resume_march_2022/git/blobs{/sha}",
        "git_tags_url": "https://api.github.com/repos/srijan2498/Resume_march_2022/git/tags{/sha}",
        "git_refs_url": "https://api.github.com/repos/srijan2498/Resume_march_2022/git/refs{/sha}",
        "trees_url": "https://api.github.com/repos/srijan2498/Resume_march_2022/git/trees{/sha}",
        "statuses_url": "https://api.github.com/repos/srijan2498/Resume_march_2022/statuses/{sha}",
        "languages_url": "https://api.github.com/repos/srijan2498/Resume_march_2022/languages",
        "stargazers_url": "https://api.github.com/repos/srijan2498/Resume_march_2022/stargazers",
        "contributors_url": "https://api.github.com/repos/srijan2498/Resume_march_2022/contributors",
        "subscribers_url": "https://api.github.com/repos/srijan2498/Resume_march_2022/subscribers",
        "subscription_url": "https://api.github.com/repos/srijan2498/Resume_march_2022/subscription",
        "commits_url": "https://api.github.com/repos/srijan2498/Resume_march_2022/commits{/sha}",
        "git_commits_url": "https://api.github.com/repos/srijan2498/Resume_march_2022/git/commits{/sha}",
        "comments_url": "https://api.github.com/repos/srijan2498/Resume_march_2022/comments{/number}",
        "issue_comment_url": "https://api.github.com/repos/srijan2498/Resume_march_2022/issues/comments{/number}",
        "contents_url": "https://api.github.com/repos/srijan2498/Resume_march_2022/contents/{+path}",
        "compare_url": "https://api.github.com/repos/srijan2498/Resume_march_2022/compare/{base}...{head}",
        "merges_url": "https://api.github.com/repos/srijan2498/Resume_march_2022/merges",
        "archive_url": "https://api.github.com/repos/srijan2498/Resume_march_2022/{archive_format}{/ref}",
        "downloads_url": "https://api.github.com/repos/srijan2498/Resume_march_2022/downloads",
        "issues_url": "https://api.github.com/repos/srijan2498/Resume_march_2022/issues{/number}",
        "pulls_url": "https://api.github.com/repos/srijan2498/Resume_march_2022/pulls{/number}",
        "milestones_url": "https://api.github.com/repos/srijan2498/Resume_march_2022/milestones{/number}",
        "notifications_url": "https://api.github.com/repos/srijan2498/Resume_march_2022/notifications{?since,all,participating}",
        "labels_url": "https://api.github.com/repos/srijan2498/Resume_march_2022/labels{/name}",
        "releases_url": "https://api.github.com/repos/srijan2498/Resume_march_2022/releases{/id}",
        "deployments_url": "https://api.github.com/repos/srijan2498/Resume_march_2022/deployments",
        "created_at": "2022-03-24T18:32:13Z",
        "updated_at": "2022-03-24T18:38:02Z",
        "pushed_at": "2022-08-10T06:44:13Z",
        "git_url": "git://github.com/srijan2498/Resume_march_2022.git",
        "ssh_url": "git@github.com:srijan2498/Resume_march_2022.git",
        "clone_url": "https://github.com/srijan2498/Resume_march_2022.git",
        "svn_url": "https://github.com/srijan2498/Resume_march_2022",
        "homepage": null,
        "size": 295,
        "stargazers_count": 0,
        "watchers_count": 0,
        "language": null,
        "has_issues": true,
        "has_projects": true,
        "has_downloads": true,
        "has_wiki": true,
        "has_pages": false,
        "has_discussions": false,
        "forks_count": 0,
        "mirror_url": null,
        "archived": false,
        "disabled": false,
        "open_issues_count": 0,
        "license": null,
        "allow_forking": true,
        "is_template": false,
        "web_commit_signoff_required": false,
        "topics": [

        ],
        "visibility": "public",
        "forks": 0,
        "open_issues": 0,
        "watchers": 0,
        "default_branch": "main"
    },
    {
        "id": 281053860,
        "node_id": "MDEwOlJlcG9zaXRvcnkyODEwNTM4NjA=",
        "name": "Tic-Tac-Toe-Game",
        "full_name": "srijan2498/Tic-Tac-Toe-Game",
        "private": false,
        "owner": {
            "login": "srijan2498",
            "id": 47470062,
            "node_id": "MDQ6VXNlcjQ3NDcwMDYy",
            "avatar_url": "https://avatars.githubusercontent.com/u/47470062?v=4",
            "gravatar_id": "",
            "url": "https://api.github.com/users/srijan2498",
            "html_url": "https://github.com/srijan2498",
            "followers_url": "https://api.github.com/users/srijan2498/followers",
            "following_url": "https://api.github.com/users/srijan2498/following{/other_user}",
            "gists_url": "https://api.github.com/users/srijan2498/gists{/gist_id}",
            "starred_url": "https://api.github.com/users/srijan2498/starred{/owner}{/repo}",
            "subscriptions_url": "https://api.github.com/users/srijan2498/subscriptions",
            "organizations_url": "https://api.github.com/users/srijan2498/orgs",
            "repos_url": "https://api.github.com/users/srijan2498/repos",
            "events_url": "https://api.github.com/users/srijan2498/events{/privacy}",
            "received_events_url": "https://api.github.com/users/srijan2498/received_events",
            "type": "User",
            "site_admin": false
        },
        "html_url": "https://github.com/srijan2498/Tic-Tac-Toe-Game",
        "description": "It is a basic game developed with GUI using JAVA as the programming language and NetBeans 8.2 IDE. It is a two-player game in which the player \"X\" will always start the game then both the players play the game one after another, unless one of the players wins the game or the game is drawn.",
        "fork": false,
        "url": "https://api.github.com/repos/srijan2498/Tic-Tac-Toe-Game",
        "forks_url": "https://api.github.com/repos/srijan2498/Tic-Tac-Toe-Game/forks",
        "keys_url": "https://api.github.com/repos/srijan2498/Tic-Tac-Toe-Game/keys{/key_id}",
        "collaborators_url": "https://api.github.com/repos/srijan2498/Tic-Tac-Toe-Game/collaborators{/collaborator}",
        "teams_url": "https://api.github.com/repos/srijan2498/Tic-Tac-Toe-Game/teams",
        "hooks_url": "https://api.github.com/repos/srijan2498/Tic-Tac-Toe-Game/hooks",
        "issue_events_url": "https://api.github.com/repos/srijan2498/Tic-Tac-Toe-Game/issues/events{/number}",
        "events_url": "https://api.github.com/repos/srijan2498/Tic-Tac-Toe-Game/events",
        "assignees_url": "https://api.github.com/repos/srijan2498/Tic-Tac-Toe-Game/assignees{/user}",
        "branches_url": "https://api.github.com/repos/srijan2498/Tic-Tac-Toe-Game/branches{/branch}",
        "tags_url": "https://api.github.com/repos/srijan2498/Tic-Tac-Toe-Game/tags",
        "blobs_url": "https://api.github.com/repos/srijan2498/Tic-Tac-Toe-Game/git/blobs{/sha}",
        "git_tags_url": "https://api.github.com/repos/srijan2498/Tic-Tac-Toe-Game/git/tags{/sha}",
        "git_refs_url": "https://api.github.com/repos/srijan2498/Tic-Tac-Toe-Game/git/refs{/sha}",
        "trees_url": "https://api.github.com/repos/srijan2498/Tic-Tac-Toe-Game/git/trees{/sha}",
        "statuses_url": "https://api.github.com/repos/srijan2498/Tic-Tac-Toe-Game/statuses/{sha}",
        "languages_url": "https://api.github.com/repos/srijan2498/Tic-Tac-Toe-Game/languages",
        "stargazers_url": "https://api.github.com/repos/srijan2498/Tic-Tac-Toe-Game/stargazers",
        "contributors_url": "https://api.github.com/repos/srijan2498/Tic-Tac-Toe-Game/contributors",
        "subscribers_url": "https://api.github.com/repos/srijan2498/Tic-Tac-Toe-Game/subscribers",
        "subscription_url": "https://api.github.com/repos/srijan2498/Tic-Tac-Toe-Game/subscription",
        "commits_url": "https://api.github.com/repos/srijan2498/Tic-Tac-Toe-Game/commits{/sha}",
        "git_commits_url": "https://api.github.com/repos/srijan2498/Tic-Tac-Toe-Game/git/commits{/sha}",
        "comments_url": "https://api.github.com/repos/srijan2498/Tic-Tac-Toe-Game/comments{/number}",
        "issue_comment_url": "https://api.github.com/repos/srijan2498/Tic-Tac-Toe-Game/issues/comments{/number}",
        "contents_url": "https://api.github.com/repos/srijan2498/Tic-Tac-Toe-Game/contents/{+path}",
        "compare_url": "https://api.github.com/repos/srijan2498/Tic-Tac-Toe-Game/compare/{base}...{head}",
        "merges_url": "https://api.github.com/repos/srijan2498/Tic-Tac-Toe-Game/merges",
        "archive_url": "https://api.github.com/repos/srijan2498/Tic-Tac-Toe-Game/{archive_format}{/ref}",
        "downloads_url": "https://api.github.com/repos/srijan2498/Tic-Tac-Toe-Game/downloads",
        "issues_url": "https://api.github.com/repos/srijan2498/Tic-Tac-Toe-Game/issues{/number}",
        "pulls_url": "https://api.github.com/repos/srijan2498/Tic-Tac-Toe-Game/pulls{/number}",
        "milestones_url": "https://api.github.com/repos/srijan2498/Tic-Tac-Toe-Game/milestones{/number}",
        "notifications_url": "https://api.github.com/repos/srijan2498/Tic-Tac-Toe-Game/notifications{?since,all,participating}",
        "labels_url": "https://api.github.com/repos/srijan2498/Tic-Tac-Toe-Game/labels{/name}",
        "releases_url": "https://api.github.com/repos/srijan2498/Tic-Tac-Toe-Game/releases{/id}",
        "deployments_url": "https://api.github.com/repos/srijan2498/Tic-Tac-Toe-Game/deployments",
        "created_at": "2020-07-20T08:03:38Z",
        "updated_at": "2020-07-20T08:05:54Z",
        "pushed_at": "2020-07-20T08:05:52Z",
        "git_url": "git://github.com/srijan2498/Tic-Tac-Toe-Game.git",
        "ssh_url": "git@github.com:srijan2498/Tic-Tac-Toe-Game.git",
        "clone_url": "https://github.com/srijan2498/Tic-Tac-Toe-Game.git",
        "svn_url": "https://github.com/srijan2498/Tic-Tac-Toe-Game",
        "homepage": null,
        "size": 62,
        "stargazers_count": 0,
        "watchers_count": 0,
        "language": "Java",
        "has_issues": true,
        "has_projects": true,
        "has_downloads": true,
        "has_wiki": true,
        "has_pages": false,
        "has_discussions": false,
        "forks_count": 0,
        "mirror_url": null,
        "archived": false,
        "disabled": false,
        "open_issues_count": 0,
        "license": null,
        "allow_forking": true,
        "is_template": false,
        "web_commit_signoff_required": false,
        "topics": [

        ],
        "visibility": "public",
        "forks": 0,
        "open_issues": 0,
        "watchers": 0,
        "default_branch": "master"
    },
    {
        "id": 235786606,
        "node_id": "MDEwOlJlcG9zaXRvcnkyMzU3ODY2MDY=",
        "name": "Voice-over-ip-Simulation",
        "full_name": "srijan2498/Voice-over-ip-Simulation",
        "private": false,
        "owner": {
            "login": "srijan2498",
            "id": 47470062,
            "node_id": "MDQ6VXNlcjQ3NDcwMDYy",
            "avatar_url": "https://avatars.githubusercontent.com/u/47470062?v=4",
            "gravatar_id": "",
            "url": "https://api.github.com/users/srijan2498",
            "html_url": "https://github.com/srijan2498",
            "followers_url": "https://api.github.com/users/srijan2498/followers",
            "following_url": "https://api.github.com/users/srijan2498/following{/other_user}",
            "gists_url": "https://api.github.com/users/srijan2498/gists{/gist_id}",
            "starred_url": "https://api.github.com/users/srijan2498/starred{/owner}{/repo}",
            "subscriptions_url": "https://api.github.com/users/srijan2498/subscriptions",
            "organizations_url": "https://api.github.com/users/srijan2498/orgs",
            "repos_url": "https://api.github.com/users/srijan2498/repos",
            "events_url": "https://api.github.com/users/srijan2498/events{/privacy}",
            "received_events_url": "https://api.github.com/users/srijan2498/received_events",
            "type": "User",
            "site_admin": false
        },
        "html_url": "https://github.com/srijan2498/Voice-over-ip-Simulation",
        "description": "A project based on voice over internet protocol(VOip) in cisco packet trace",
        "fork": false,
        "url": "https://api.github.com/repos/srijan2498/Voice-over-ip-Simulation",
        "forks_url": "https://api.github.com/repos/srijan2498/Voice-over-ip-Simulation/forks",
        "keys_url": "https://api.github.com/repos/srijan2498/Voice-over-ip-Simulation/keys{/key_id}",
        "collaborators_url": "https://api.github.com/repos/srijan2498/Voice-over-ip-Simulation/collaborators{/collaborator}",
        "teams_url": "https://api.github.com/repos/srijan2498/Voice-over-ip-Simulation/teams",
        "hooks_url": "https://api.github.com/repos/srijan2498/Voice-over-ip-Simulation/hooks",
        "issue_events_url": "https://api.github.com/repos/srijan2498/Voice-over-ip-Simulation/issues/events{/number}",
        "events_url": "https://api.github.com/repos/srijan2498/Voice-over-ip-Simulation/events",
        "assignees_url": "https://api.github.com/repos/srijan2498/Voice-over-ip-Simulation/assignees{/user}",
        "branches_url": "https://api.github.com/repos/srijan2498/Voice-over-ip-Simulation/branches{/branch}",
        "tags_url": "https://api.github.com/repos/srijan2498/Voice-over-ip-Simulation/tags",
        "blobs_url": "https://api.github.com/repos/srijan2498/Voice-over-ip-Simulation/git/blobs{/sha}",
        "git_tags_url": "https://api.github.com/repos/srijan2498/Voice-over-ip-Simulation/git/tags{/sha}",
        "git_refs_url": "https://api.github.com/repos/srijan2498/Voice-over-ip-Simulation/git/refs{/sha}",
        "trees_url": "https://api.github.com/repos/srijan2498/Voice-over-ip-Simulation/git/trees{/sha}",
        "statuses_url": "https://api.github.com/repos/srijan2498/Voice-over-ip-Simulation/statuses/{sha}",
        "languages_url": "https://api.github.com/repos/srijan2498/Voice-over-ip-Simulation/languages",
        "stargazers_url": "https://api.github.com/repos/srijan2498/Voice-over-ip-Simulation/stargazers",
        "contributors_url": "https://api.github.com/repos/srijan2498/Voice-over-ip-Simulation/contributors",
        "subscribers_url": "https://api.github.com/repos/srijan2498/Voice-over-ip-Simulation/subscribers",
        "subscription_url": "https://api.github.com/repos/srijan2498/Voice-over-ip-Simulation/subscription",
        "commits_url": "https://api.github.com/repos/srijan2498/Voice-over-ip-Simulation/commits{/sha}",
        "git_commits_url": "https://api.github.com/repos/srijan2498/Voice-over-ip-Simulation/git/commits{/sha}",
        "comments_url": "https://api.github.com/repos/srijan2498/Voice-over-ip-Simulation/comments{/number}",
        "issue_comment_url": "https://api.github.com/repos/srijan2498/Voice-over-ip-Simulation/issues/comments{/number}",
        "contents_url": "https://api.github.com/repos/srijan2498/Voice-over-ip-Simulation/contents/{+path}",
        "compare_url": "https://api.github.com/repos/srijan2498/Voice-over-ip-Simulation/compare/{base}...{head}",
        "merges_url": "https://api.github.com/repos/srijan2498/Voice-over-ip-Simulation/merges",
        "archive_url": "https://api.github.com/repos/srijan2498/Voice-over-ip-Simulation/{archive_format}{/ref}",
        "downloads_url": "https://api.github.com/repos/srijan2498/Voice-over-ip-Simulation/downloads",
        "issues_url": "https://api.github.com/repos/srijan2498/Voice-over-ip-Simulation/issues{/number}",
        "pulls_url": "https://api.github.com/repos/srijan2498/Voice-over-ip-Simulation/pulls{/number}",
        "milestones_url": "https://api.github.com/repos/srijan2498/Voice-over-ip-Simulation/milestones{/number}",
        "notifications_url": "https://api.github.com/repos/srijan2498/Voice-over-ip-Simulation/notifications{?since,all,participating}",
        "labels_url": "https://api.github.com/repos/srijan2498/Voice-over-ip-Simulation/labels{/name}",
        "releases_url": "https://api.github.com/repos/srijan2498/Voice-over-ip-Simulation/releases{/id}",
        "deployments_url": "https://api.github.com/repos/srijan2498/Voice-over-ip-Simulation/deployments",
        "created_at": "2020-01-23T12:05:22Z",
        "updated_at": "2020-01-23T13:24:35Z",
        "pushed_at": "2020-01-23T13:24:33Z",
        "git_url": "git://github.com/srijan2498/Voice-over-ip-Simulation.git",
        "ssh_url": "git@github.com:srijan2498/Voice-over-ip-Simulation.git",
        "clone_url": "https://github.com/srijan2498/Voice-over-ip-Simulation.git",
        "svn_url": "https://github.com/srijan2498/Voice-over-ip-Simulation",
        "homepage": null,
        "size": 535,
        "stargazers_count": 0,
        "watchers_count": 0,
        "language": null,
        "has_issues": true,
        "has_projects": true,
        "has_downloads": true,
        "has_wiki": true,
        "has_pages": false,
        "has_discussions": false,
        "forks_count": 0,
        "mirror_url": null,
        "archived": false,
        "disabled": false,
        "open_issues_count": 0,
        "license": null,
        "allow_forking": true,
        "is_template": false,
        "web_commit_signoff_required": false,
        "topics": [

        ],
        "visibility": "public",
        "forks": 0,
        "open_issues": 0,
        "watchers": 0,
        "default_branch": "master"
    },
    {
        "id": 479505752,
        "node_id": "R_kgDOHJStWA",
        "name": "Walpic",
        "full_name": "srijan2498/Walpic",
        "private": false,
        "owner": {
            "login": "srijan2498",
            "id": 47470062,
            "node_id": "MDQ6VXNlcjQ3NDcwMDYy",
            "avatar_url": "https://avatars.githubusercontent.com/u/47470062?v=4",
            "gravatar_id": "",
            "url": "https://api.github.com/users/srijan2498",
            "html_url": "https://github.com/srijan2498",
            "followers_url": "https://api.github.com/users/srijan2498/followers",
            "following_url": "https://api.github.com/users/srijan2498/following{/other_user}",
            "gists_url": "https://api.github.com/users/srijan2498/gists{/gist_id}",
            "starred_url": "https://api.github.com/users/srijan2498/starred{/owner}{/repo}",
            "subscriptions_url": "https://api.github.com/users/srijan2498/subscriptions",
            "organizations_url": "https://api.github.com/users/srijan2498/orgs",
            "repos_url": "https://api.github.com/users/srijan2498/repos",
            "events_url": "https://api.github.com/users/srijan2498/events{/privacy}",
            "received_events_url": "https://api.github.com/users/srijan2498/received_events",
            "type": "User",
            "site_admin": false
        },
        "html_url": "https://github.com/srijan2498/Walpic",
        "description": "It is a web app which makes use of unsplash api. Using this, one can search and select the wallpapers of his choice. It includes Html, CSS, JavaScript and jQuery, Ajax.",
        "fork": false,
        "url": "https://api.github.com/repos/srijan2498/Walpic",
        "forks_url": "https://api.github.com/repos/srijan2498/Walpic/forks",
        "keys_url": "https://api.github.com/repos/srijan2498/Walpic/keys{/key_id}",
        "collaborators_url": "https://api.github.com/repos/srijan2498/Walpic/collaborators{/collaborator}",
        "teams_url": "https://api.github.com/repos/srijan2498/Walpic/teams",
        "hooks_url": "https://api.github.com/repos/srijan2498/Walpic/hooks",
        "issue_events_url": "https://api.github.com/repos/srijan2498/Walpic/issues/events{/number}",
        "events_url": "https://api.github.com/repos/srijan2498/Walpic/events",
        "assignees_url": "https://api.github.com/repos/srijan2498/Walpic/assignees{/user}",
        "branches_url": "https://api.github.com/repos/srijan2498/Walpic/branches{/branch}",
        "tags_url": "https://api.github.com/repos/srijan2498/Walpic/tags",
        "blobs_url": "https://api.github.com/repos/srijan2498/Walpic/git/blobs{/sha}",
        "git_tags_url": "https://api.github.com/repos/srijan2498/Walpic/git/tags{/sha}",
        "git_refs_url": "https://api.github.com/repos/srijan2498/Walpic/git/refs{/sha}",
        "trees_url": "https://api.github.com/repos/srijan2498/Walpic/git/trees{/sha}",
        "statuses_url": "https://api.github.com/repos/srijan2498/Walpic/statuses/{sha}",
        "languages_url": "https://api.github.com/repos/srijan2498/Walpic/languages",
        "stargazers_url": "https://api.github.com/repos/srijan2498/Walpic/stargazers",
        "contributors_url": "https://api.github.com/repos/srijan2498/Walpic/contributors",
        "subscribers_url": "https://api.github.com/repos/srijan2498/Walpic/subscribers",
        "subscription_url": "https://api.github.com/repos/srijan2498/Walpic/subscription",
        "commits_url": "https://api.github.com/repos/srijan2498/Walpic/commits{/sha}",
        "git_commits_url": "https://api.github.com/repos/srijan2498/Walpic/git/commits{/sha}",
        "comments_url": "https://api.github.com/repos/srijan2498/Walpic/comments{/number}",
        "issue_comment_url": "https://api.github.com/repos/srijan2498/Walpic/issues/comments{/number}",
        "contents_url": "https://api.github.com/repos/srijan2498/Walpic/contents/{+path}",
        "compare_url": "https://api.github.com/repos/srijan2498/Walpic/compare/{base}...{head}",
        "merges_url": "https://api.github.com/repos/srijan2498/Walpic/merges",
        "archive_url": "https://api.github.com/repos/srijan2498/Walpic/{archive_format}{/ref}",
        "downloads_url": "https://api.github.com/repos/srijan2498/Walpic/downloads",
        "issues_url": "https://api.github.com/repos/srijan2498/Walpic/issues{/number}",
        "pulls_url": "https://api.github.com/repos/srijan2498/Walpic/pulls{/number}",
        "milestones_url": "https://api.github.com/repos/srijan2498/Walpic/milestones{/number}",
        "notifications_url": "https://api.github.com/repos/srijan2498/Walpic/notifications{?since,all,participating}",
        "labels_url": "https://api.github.com/repos/srijan2498/Walpic/labels{/name}",
        "releases_url": "https://api.github.com/repos/srijan2498/Walpic/releases{/id}",
        "deployments_url": "https://api.github.com/repos/srijan2498/Walpic/deployments",
        "created_at": "2022-04-08T18:55:56Z",
        "updated_at": "2022-04-08T18:58:29Z",
        "pushed_at": "2022-04-08T18:58:26Z",
        "git_url": "git://github.com/srijan2498/Walpic.git",
        "ssh_url": "git@github.com:srijan2498/Walpic.git",
        "clone_url": "https://github.com/srijan2498/Walpic.git",
        "svn_url": "https://github.com/srijan2498/Walpic",
        "homepage": null,
        "size": 683,
        "stargazers_count": 0,
        "watchers_count": 0,
        "language": "CSS",
        "has_issues": true,
        "has_projects": true,
        "has_downloads": true,
        "has_wiki": true,
        "has_pages": false,
        "has_discussions": false,
        "forks_count": 0,
        "mirror_url": null,
        "archived": false,
        "disabled": false,
        "open_issues_count": 0,
        "license": null,
        "allow_forking": true,
        "is_template": false,
        "web_commit_signoff_required": false,
        "topics": [

        ],
        "visibility": "public",
        "forks": 0,
        "open_issues": 0,
        "watchers": 0,
        "default_branch": "main"
    }
]

export {uData, rData}